import { motion } from 'framer-motion';
import { COLORS } from '../utils/colors';

interface LoginLayoutProps {
}

const LoginLayout = ({ children }: any) => {
  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <div
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          width: '100%',
          position: 'relative'
        }}
      >
        <img
          src={'./logo.png'}
          width={100}
          alt={'next is free logo'}
          style={{ position: 'absolute', left: 15, top: 15 }}
        />
        <div
          className={'w-full max-w-md p-4'}
        >
          {children}
        </div>
      </div>
      <div className="hide-mob p-8 relative w-[45%]">
        <div className={'bg-slate-900 w-full h-full rounded-2xl'}>
          <img src={'./logo-white.png'} style={{
            position: 'absolute',
            top: '50%',
            width: '80%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 180
          }} />
        </div>
      </div>
    </div>
  );
};
export default LoginLayout;
